import React from 'react';
import s from './Events.module.css';
import job from './../../../../assets/img/Event/newJob.jpg';
import meeting from './../../../../assets/img/Event/meeting.jpg';

const Events = () => {
    return (
        <div className={s.eventsBlock}>
            <div className={s.titleBlock}>
                <span className={s.title}>Life Event</span>
                <span>
                    <a className={s.createEventLink} href="#">Create</a>
                </span>
            </div>
            <div className={s.event}>
                <div className={s.photoEvent}>
                    <a href="#">
                        <img src={job} alt="photo event"/>
                    </a>
                </div>
                <div className={s.eventContent}>
                    <div className={s.eventTitle}>Started New Job at Apple</div>
                    <div className={s.eventDate}>December 15, 2021</div>
                </div>
            </div>
            <div className={s.event}>
                <div className={s.photoEvent}>
                    <a href="#">
                        <img src={meeting} alt="photo event"/>
                    </a>
                </div>
                <div className={s.eventContent}>
                    <div className={s.eventTitle}>Meeting</div>
                    <div className={s.eventDate}>January 10, 2021</div>
                </div>
            </div>
        </div>
    )
}

export default Events
